export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-male-female-476f03f326deae40c6be5be1fc40bb82.svg";